<template>
  <div class="verify-items">
    <div v-for="(item, i) in verifyItems" :key="i">
      <el-input v-model="verifyItems[i]" style="margin-top: 10px">
        <template v-slot:append>
          <el-button
            icon="el-icon-delete"
            @click="$emit('deleteItem', i)"
            style="float: right;"
            size="mini"
          ></el-button>
        </template>
      </el-input>
    </div>
    <el-button
      type="success"
      size="mini"
      icon="el-icon-plus"
      :round="true"
      @click="$emit('addItem')"
      style="margin-top: 10px"
    >
      增加选项
    </el-button>
  </div>
</template>

<script>
export default {
  name: "verifyItems",
  props: {
    verifyItems: Array
  },
  methods: {
    output() {
      return this.verifyItems.filter(item => item.trim())
    }
  }
}
</script>
<style lang="scss" scoped></style>
